import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './value-proposition-item.component.scss';
var ValuePropositionItem = /** @class */ (function (_super) {
    tslib_1.__extends(ValuePropositionItem, _super);
    function ValuePropositionItem(element) {
        return _super.call(this, element) || this;
    }
    ValuePropositionItem.prototype.init = function () { };
    ValuePropositionItem.prototype.bindEvents = function () { };
    return ValuePropositionItem;
}(Base));
export { ValuePropositionItem };



//////////////////
// WEBPACK FOOTER
// ./components/value-proposition-item/value-proposition-item.component.ts
// module id = 553
// module chunks = 0